import { useState, useEffect } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, Calendar, ArrowRight, ExternalLink } from "lucide-react";
import PageHero from "./PageHero";

const KennelPlans = () => {
  const { API } = useOutletContext();
  const [plans, setPlans] = useState([]);
  useEffect(() => { fetch(`${API}/breeding-plans`).then(r => r.json()).then(setPlans).catch(() => {}); }, [API]);

  return (
    <div>
      <PageHero
        breadcrumbs={[{ label: "PLANY HODOWLANE" }]}
        label="PLANY HODOWLANE"
        title="Plany tworzone z myślą o przyszłości"
        description="Każdy planowany miot to rezultat długich przemyśleń, analizy linii hodowlanych i poszukiwania najlepszego partnera dla naszych suk. Zależy nam na zdrowiu, stabilnym charakterze i pięknej budowie. Tu znajdziesz informacje o tym, co planujemy."
        testId="plans"
      />
      <div className="px-6 md:px-12 py-12 max-w-7xl mx-auto space-y-8">
        {plans.map((p, i) => (
          <motion.div key={p.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }}
            className="bg-[#1A1A1D] border border-[#2A2A2D] hover:border-[#D4AF37]/20 overflow-hidden transition-all duration-500 group"
          >
            {/* Parents photos */}
            {(p.mother_image || p.father_image) && (
              <div className="grid grid-cols-2 gap-px bg-[#2A2A2D]">
                <div className="bg-[#141416] aspect-[4/3] overflow-hidden relative">
                  {p.mother_image && <img src={p.mother_image} alt={p.mother_name} className="w-full h-full object-cover object-center" style={p.id === 'plan-tala-quattro-2026' ? { transform: 'scaleX(-1)' } : {}} />}
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0B0B0D] to-transparent p-4">
                    <p className="text-[#D4AF37] text-xs tracking-wider">MATKA</p>
                    <p className="text-[#F5F5F5] font-serif">{p.mother_name}</p>
                  </div>
                </div>
                <div className="bg-[#141416] aspect-[4/3] overflow-hidden relative">
                  {p.father_image && <img src={p.father_image} alt={p.father_name} className="w-full h-full object-cover object-center" />}
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0B0B0D] to-transparent p-4">
                    <p className="text-[#D4AF37] text-xs tracking-wider">OJCIEC</p>
                    <p className="text-[#F5F5F5] font-serif">{p.father_name}</p>
                    {p.father_link && (
                      <a href={p.father_link} target="_blank" rel="noopener noreferrer" className="text-[#B8B8B8]/50 text-xs hover:text-[#D4AF37] flex items-center gap-1 mt-1">
                        working-dog.com <ExternalLink className="w-3 h-3" />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            )}
            
            <div className="p-8 md:p-12">
              <div className="flex items-start justify-between mb-4">
                <h2 className="font-serif text-2xl text-[#F5F5F5] group-hover:text-[#D4AF37] transition-colors">{p.title}</h2>
                {p.expected_date && <span className="text-[10px] tracking-[0.15em] text-[#D4AF37] border border-[#D4AF37]/20 px-3 py-1 flex items-center gap-1"><Calendar className="w-3 h-3" /> {p.expected_date}</span>}
              </div>
              <p className="text-[#B8B8B8]/60 text-sm mb-4 flex items-center gap-2"><Heart className="w-4 h-4 text-[#C8A96A]/40" /> {p.mother_name} × {p.father_name}</p>
              {p.father_reg && <p className="text-[#B8B8B8]/40 text-xs mb-2">Nr rodowodu ojca: {p.father_reg}</p>}
              {p.description && <p className="text-[#B8B8B8]/40 text-sm leading-relaxed mb-6">{p.description}</p>}
              <Link to="/kontakt" className="text-xs tracking-[0.15em] text-[#D4AF37] hover:text-[#F5F5F5] transition-colors flex items-center gap-2">ZAPYTAJ O SZCZENIETA <ArrowRight className="w-3.5 h-3.5" /></Link>
            </div>
          </motion.div>
        ))}
        {plans.length === 0 && <p className="text-[#B8B8B8]/30 text-center py-24 text-sm">Brak planów hodowlanych</p>}
      </div>
    </div>
  );
};
export default KennelPlans;
